var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuSleepdiary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 11.9606C15.2737 13.3975 14.1974 14.6099 12.8666 15.4548C11.5695 16.2789 10.0303 16.7565 8.38013 16.7565C6.06652 16.7565 3.97106 15.8181 2.45483 14.3017C0.938445 12.7853 0 10.6897 0 8.37639C0 6.5493 0.586618 4.85654 1.58225 3.47837C2.60412 2.06295 4.05645 0.979195 5.74577 0.42006C5.92605 0.36086 6.12115 0.459079 6.18035 0.639365C6.21196 0.734892 6.19918 0.83446 6.15276 0.915861C5.92202 1.41166 5.74172 1.93706 5.62064 2.48261C5.50157 3.0181 5.43833 3.57916 5.43833 4.15844C5.43833 6.28218 6.29942 8.20556 7.69123 9.5968C9.08244 10.988 11.0064 11.8497 13.1296 11.8497C13.5514 11.8497 13.9617 11.8167 14.358 11.7528C14.7623 11.6876 15.1606 11.5893 15.548 11.4609C15.7283 11.4017 15.9234 11.4999 15.9826 11.6802C16.0142 11.777 16.0015 11.8773 15.9544 11.9587L15.9551 11.9606Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuSleepdiary);
export default __webpack_public_path__ + "static/media/course_menu_sleepdiary.50cea6f62c3400fcf6c2c1ec873486b1.svg";
export { ForwardRef as ReactComponent };